export default __webpack_public_path__ + "static/media/shot.c5720bd0.svg";